import ReactPixel from 'react-facebook-pixel';

ReactPixel.init('879747843288707')

export {ReactPixel}